import {Component, computed, effect, inject, input, model} from '@angular/core';
import {NotFoundComponent} from "../../not-found/not-found.component";
import {Page, SrmPointSummaryReport, SrmPointSummaryReportSearchParam} from "../../../../generated-model/model";
import {DecimalPipe} from "@angular/common";
import {IgnoreNullHttpParams} from "../../commons/Ignore-null-http-params";
import {SrmPointSummaryReportResource} from "../../../service/SrmPointSummaryReportResource";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-point-summary-report-bkk-table',
  standalone: true,
  imports: [
    NotFoundComponent,
    DecimalPipe,
    NgbPagination
  ],
  templateUrl: './point-summary-report-bkk-table.component.html',
  styleUrl: './point-summary-report-bkk-table.component.scss'
})
export class PointSummaryReportBkkTableComponent {
  pageDataBkk = model<Page<SrmPointSummaryReport>>({number: 0, size: 50});
  currentMonth = computed(() => this.pageDataBkk()?.content?.[0]?.currMonth);
  prevMonth = computed(() => this.pageDataBkk()?.content?.[0]?.prevMonth);
  params = input<SrmPointSummaryReportSearchParam>();
  srmPointSummaryReportResource = inject(SrmPointSummaryReportResource);

  constructor() {
    effect(() => {
      this.currentMonth();
      this.prevMonth();
      console.log('this.prevMonth', this.prevMonth());
      console.log('this.currMonth', this.currentMonth());
    });
  }

  searchBkk(page: number = 1) {
    const param = IgnoreNullHttpParams.fromObject({
      ...this.params(),
      page: page - 1,
      size: this.pageDataBkk().size,
      sort: 'hmainOp.htitle'
    })
    this.srmPointSummaryReportResource.searchBkk(param)
      .subscribe(e => {
        this.pageDataBkk.set(e);
      });
  }
}
